import { forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'

type DefinePrimitive = <T extends keyof JSX.IntrinsicElements>(options: {
  name: string
  element: T
  className?: string | undefined
}) => (props: JSX.IntrinsicElements[T]) => JSX.Element

const definePrimitive: DefinePrimitive = ({
  name,
  element,
  className
}) => {
  const Component = element as any

  const Primitive: any = forwardRef((props: any, ref) => (
    <Component
      {...props}
      ref={ref}
      className={twMerge(className, props.className)}
    />
  ))

  Primitive.displayName = name
  return Primitive
}

export default definePrimitive
